import { onAuthStateChanged } from 'firebase/auth'
import { auth } from '@learnics/services/src/analyticsConfig'
import { store } from '@/store'
import { createLoginArguments } from '@/utils/gapi/createLoginArguments'
import { openOauthLoginPopup } from '@/utils/gapi/openOauthLoginPopup'
import { oauthProviderLabels } from '@/utils/gapi/redirectToOauthLogin'

export async function customOauthLoginWithPopup(
  state,
  providerId = null, // The provider ID to use for the OAuth login
  user,
  scopes,
  prompt = 'none', // We always default to none.  If that fails, the popup will automatically upgrade to select_account.  If that fails, the call will be tried once more with "consent".
  linkingGoogleAccount = false,
  showWarning = false,
  warningMessage,
  customToken = null, // A custom token to sign in with beforehand, if available
) {
  console.log(
    'Custom OAuth login with popup called',
    providerId,
    showWarning,
    warningMessage,
    customToken,
  )
  const loginArgs = createLoginArguments(
    state,
    user,
    scopes,
    prompt,
    false,
    linkingGoogleAccount,
    showWarning,
    warningMessage,
    null,
    providerId,
  )
  console.log('loginArgs', loginArgs)

  console.warn('Scopes', scopes)
  return await new Promise((resolve, reject) => {
    const popupWindow = openOauthLoginPopup(loginArgs, customToken, providerId)
    if (!popupWindow) {
      reject('Failed to open popup window')
      return
    }

    let pollTimer, eventListener

    eventListener = async (event) => {
      if (event.origin !== window.location.origin) {
        return
      }
      const { data } = event
      console.log('Received data from popup', data)
      window.clearInterval(pollTimer)
      window.removeEventListener('message', eventListener)

      if (!auth.currentUser && data.tokens) {
        // At this point the user SHOULD be logged in with firebase... if they
        // aren't, then register an auth state listener to wait for it to occur,
        // THEN resolve the promise
        try {
          const authListener = onAuthStateChanged(auth, async (user) => {
            if (user) {
              authListener()
              const token = await user.getIdTokenResult()
              const claims = token.claims || {}
              await store.dispatch('updateUser', {
                user,
                claims,
              })
              resolve(data)
            }
          })
        } catch (error) {
          console.log('Error registering auth state listener', error)
          reject(error)
        }
      } else {
        resolve(data)
      }
    }
    window.addEventListener('message', eventListener, false)

    // Poll popupWindow until it is closed or a message is received - this is
    // the only way to reliably check if the user has closed the popup without
    // going through the redirect flow

    pollTimer = window.setInterval(() => {
      try {
        if (!popupWindow || popupWindow.closed !== false) {
          // !== is required for compatibility with Opera
          window.clearInterval(pollTimer)
          window.removeEventListener('message', eventListener)
          reject(new Error('Popup was closed by user'))
        }
      } catch (e) {}
    }, 200)
  })
}
